import { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Tooltip,
  IconButton,
  Dialog,
  DialogContent,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseExpressReport } from "./UseExpressReport";
import { useSearchParams } from "react-router-dom";
import CustomPagination from "../../components/CustomPagination";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import ListAltIcon from "@mui/icons-material/ListAlt";
import RefreshIcon from "@mui/icons-material/Refresh";
import LogesticDetails from "./LogesticDetails";

export default function ExpressOrderDetails() {
  const { enqueueSnackbar } = useSnackbar();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { updateAlopeykOrder, getExpressById } = UseExpressReport();
  const [detailRes, setDetailRes] = useState();

  const [openDialog, setOpenDialog] = useState({
    show: false,
    model: "",
    id: undefined,
  });
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("oid")) {
      setProgress(true);

      getExpressById(searchParams.get("oid"), (details) => {
        setDetailRes(details);
      });
    }
  }, [searchParams]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowIndex",
      width: 70,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "logesticName",
      headerName: "لجستیک",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.logesticName}
          </Typography>
        );
      },
    },
    {
      field: "shamsiLogdate",
      headerName: "ثبت",
      width: 160,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
              direction: "rtl",
              textAlign: "center",
            }}
          >
            {cellValues.row.shamsiLogdate}
          </Typography>
        );
      },
    },

    {
      field: "shamsiPicking",
      headerName: "ارسال",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", direction: "rtl", textAlign: "center" }}
          >
            {cellValues.row.shamsiPicking}
          </Typography>
        );
      },
    },
    {
      field: "shamsiFinished",
      headerName: "تحویل",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", direction: "rtl", textAlign: "center" }}
          >
            {cellValues.row.shamsiFinished}
          </Typography>
        );
      },
    },
    {
      field: "reciveEstimateTime",
      headerName: "تخمین",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", direction: "rtl", textAlign: "center" }}
          >
            {cellValues.row.reciveEstimateTime}
          </Typography>
        );
      },
    },
    {
      field: "status",
      headerName: "وضعیت",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.status}
          </Typography>
        );
      },
    },
    {
      field: "operatorName",
      headerName: "اوپراتور",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.operatorName}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 110,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="جزئیات">
              <IconButton
                onClick={() => {
                  setOpenDialog({
                    show: true,
                    model: cellValues.row,
                    id: cellValues.row.id,
                  });
                }}
              >
                <ListAltIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="رفرش">
              <IconButton
                onClick={() => {
                  setProgress(true);
                  let state = { id: cellValues.row.id };
                  updateAlopeykOrder(state, () => {
                    getExpressById(searchParams.get("oid"), (details) => {
                      setDetailRes(details);
                    });
                  });
                }}
              >
                <RefreshIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        backButtonDef: true,
        backURL: "/expressorderreports",
        title: "گزارشات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/expressorderreports" },
          {
            name: "جزئیات سفارش " + "(" + searchParams.get("oid") + ")",
            url: "/expressorderreports/orderDetail",
          },
        ],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        maxWidth="lg"
        open={openDialog.show}
        onClose={() => {
          setOpenDialog({ show: false, model: "", id: undefined });
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            width: "100%",
          }}
        >
          <LogesticDetails
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            detailRes={detailRes?.logestic}
            callback={() => {
              getExpressById(searchParams.get("oid"), (details) => {
                setDetailRes(details);
              });
            }}
          />
        </DialogContent>
      </Dialog>
      <DataGrid
        className="ltr-grid"
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={detailRes?.logestic ? detailRes.logestic : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={
          detailRes?.logestic && detailRes?.logestic.length
            ? detailRes.logestic.length
            : 1
        }
        enableRangeSelection={true}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        sx={{
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "&  .MuiDataGrid-columnHeader:focus-within": {
            outline: "none",
          },
          "&  .MuiDataGrid-cell:focus-within ": {
            outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
          },
          "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
            outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
          },
          "& .MuiDataGrid-cell:hover": {
            opacity: "80%",
            cursor: "pointer",
          },
          "& .MuiDataGrid-virtualScrollerRenderZone": {
            width: "100% !important",
          },
          "& .Green": {
            backgroundColor: "#56ff004f !important",
          },
          "& .red": {
            backgroundColor: "#ff9c9c !important",
          },
        }}
        getRowClassName={(params) => {
          if (params.row.status == "تحویل شد") {
            return "Green";
          }
          if (params.row.status && params.row.status == "کنسل شد") {
            return "red";
          }
        }}
        componentsProps={{
          pagination: {
            isLtr: true,
            nofab: true,
            rowCount:
              detailRes?.logestic && detailRes.logestic.length
                ? detailRes.logestic.length
                : "",
          },
        }}
      />
    </Detail>
  );
}
